import {
  fetchUserInspectionRequest,
  editUserInspectionRequest,
  CreateUserInspectionRequestType,
} from 'api';
import { setAuthLoading, setUserInspection } from 'state/actions';
import { TypedDispatch } from 'state/types';

export const fetchUserInspection =
  (inspectionId: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await fetchUserInspectionRequest(inspectionId);

      dispatch(setUserInspection(response?.data));

      return response?.data;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const editUserInspection =
  (userInspection: CreateUserInspectionRequestType) =>
  async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editUserInspectionRequest(userInspection);

      return response;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
